import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "search-user-block"
};
var _hoisted_2 = {
  class: "options"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_user_cell = _resolveComponent("user-cell");
  var _component_el_option = _resolveComponent("el-option");
  var _component_infinite_loading = _resolveComponent("infinite-loading");
  var _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_select, {
    placeholder: _ctx.placeholder,
    filterable: "",
    remote: "",
    "remote-method": _ctx.searchAuthors,
    modelValue: _ctx.textSearched,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.textSearched = $event;
    }),
    onChange: _ctx.select,
    clearable: true,
    onClear: _ctx.onClearSelection,
    onBlur: _ctx.onBlur,
    "popper-class": "search-user-select-popper",
    "no-data-text": _ctx.isFetching ? _ctx.$t('copy_speaches.speaches_setup.table.new_author_loading') : _ctx.$t('copy_speaches.speaches_setup.table.new_author_no_result')
  }, {
    default: _withCtx(function (scope) {
      return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authors, function (author) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: author.userID,
          label: author.email,
          value: author
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_user_cell, {
              image: author.image,
              "first-name": author.firstName,
              "last-name": author.lastName,
              email: author.email
            }, null, 8, ["image", "first-name", "last-name", "email"])];
          }),
          _: 2
        }, 1032, ["label", "value"]);
      }), 128))]), _createVNode(_component_infinite_loading, {
        onInfinite: _ctx.searchAuthorsInfiniteLoader,
        identifier: _ctx.infiniteLoaderID
      }, {
        "no-more": _withCtx(function () {
          return [_hoisted_3];
        }),
        "no-results": _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      }, 8, ["onInfinite", "identifier"])];
    }),
    _: 1
  }, 8, ["placeholder", "remote-method", "modelValue", "onChange", "onClear", "onBlur", "no-data-text"])]);
}